// eslint-disable-next-line prefer-regex-literals
export const VALID_URL_REGEX = new RegExp(
  '^(http[s]?:\\/\\/)?[^\\/\\s(["<,>]*\\.[^\\s[",><]*$',
  "i",
); // fragment locator

const validateURL = (str?: string) => {
  if (str) {
    return !!VALID_URL_REGEX.test(str);
  }

  return false;
};

export default validateURL;
